import React, { Component } from 'react';
import { Badge, Icon, message, Table } from 'antd';
import { Link } from 'react-router';
import moment from 'moment';
import { querySetTaskCollect, querySetTaskUnCollect } from '@api/task';

class TableInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }

  componentWillMount() {}

  componentDidMount() {
    const { data } = this.props;
    this.setState({ data });
  }

  componentWillReceiveProps(nextProps) {
    const { data } = nextProps;
    if (data !== this.props.data) {
      this.setState({ data });
    }
  }

  setTaskCollect = record => {
    const { data } = this.state;

    querySetTaskCollect({ uuid: record.uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        record.collectFlag = true;
        this.setState({ data });
      } else {
        message.error(res.message);
      }
    });
  };

  setTaskUnCollect = record => {
    const { data } = this.state;

    querySetTaskUnCollect({ uuid: record.uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        record.collectFlag = false;
        this.setState({ data });
      } else {
        message.error(res.message);
      }
    });
  };

  columns = () => {
    return [
      {
        title: '',
        dataIndex: 'collectFlag',
        width: 30,
        render: (text, record) => {
          if (text) {
            return (
              <Icon
                type="heart"
                style={{
                  color: 'red',
                }}
                theme="filled"
                onClick={() => this.setTaskUnCollect(record)}
              />
            );
          }
          return <Icon type="heart" theme="outlined" onClick={() => this.setTaskCollect(record)} />;
        },
      },
      {
        title: '任务名称',
        dataIndex: 'name',
        render: (text, record) => {
          return <Link to={`/task/task_detail/${record.uuid}`}>{text}</Link>;
        },
      },
      {
        title: '开始时间',
        dataIndex: 'beginDate',
        key: 'beginDate',
        render: (text, record) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '截至时间',
        dataIndex: 'endDate',
        key: 'endDate',
        render: (text, record) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '相关人员',
        dataIndex: 'executives',
        key: 'executives',
        render: (text, record) => {
          return (
            <div>
              <p>
                <span style={{ color: '#D8D1CF' }}>执</span>
                {record.executives.map(item => {
                  return (
                    <span style={{ paddingLeft: '5px', paddingRight: '5px' }} key={item.uuid}>
                      {item.userName}
                    </span>
                  );
                })}
              </p>
              <p style={{ marginBottom: '0' }}>
                <span style={{ color: '#D8D1CF' }}>协</span>
                {record.assistants.map(item => {
                  return (
                    <span style={{ paddingLeft: '5px', paddingRight: '5px' }} key={item.uuid}>
                      {item.userName}
                    </span>
                  );
                })}
              </p>
            </div>
          );
        },
      },
      {
        title: '状态',
        dataIndex: 'status',
        render: (text, record) => {
          if (record.status === 1) {
            switch (record.fettle) {
              case 1:
                return <Badge color="red" text="已逾期" />;
              case 2:
                return <Badge color="blue" text="进行中" />;
              case 3:
                return <Badge color="yellow" text="未开始" />;
              default:
            }
          } else if (record.status === 2) {
            switch (record.fettle) {
              case 1:
                return <Badge color="red" text="未完成" />;
              case 2:
                return <Badge color="green" text="已完成" />;
              case 3:
                return <Badge color="gray" text="已废弃" />;
              default:
            }
          } else if (record.status === 0) {
            return <Badge color="yellow" text="待编辑" />;
          }
        },
      },
    ];
  };

  render() {
    const { data, pagination, isLoading } = this.props;
    return (
      <Table
        size="small"
        columns={this.columns()}
        dataSource={data}
        pagination={pagination}
        rowKey="uuid"
        loading={isLoading}
        onChange={this.props.onChange}
      />
    );
  }
}

export default TableInformation;



// WEBPACK FOOTER //
// ./src/components/task/project/pageDetail/TableTask.js